import React from 'react';
import './Cookie.css';
import Table from 'react-bootstrap/Table';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Cookies from "js-cookie";

class CookiePage extends React.Component {
    rechazarCookiesGA() {
        const obj = Cookies.get();
    }

    aceptarCookiesGa() {
    }

    render() {
        return (
            <Container className="cookies text-justify float-center my-4">
                <Card>
                    <Card.Header as="h5">Política de Cookies</Card.Header>
                    <Card.Body>
                        <div className="politics">
                            <h3 className="text-center">POLÍTICA DE COOKIES</h3>
                            <br />

                            <h4>1.- ANTECEDENTES</h4>
                            <p>
                                De conformidad con la normativa española que regula el uso de cookies en relación a la prestación de servicios de comunicaciones electrónicas, recogida en el artículo 22.2 de la Ley 34/2002, del 11 de julio, de servicios de la sociedad de la información y de comercio electrónico, le informamos sobre las cookies utilizadas en el sitio web de Gecor System S.L.U. y el motivo de su uso.
                            </p>
                            <br />

                            <h4>2.- ¿QUÉ SON LAS COOKIES?</h4>
                            <p>
                                Una cookie es un fichero que se descarga en su ordenador al acceder a determinadas páginas web. Las cookies permiten a una página web, entre otras cosas, almacenar y recuperar información sobre los hábitos de navegación de un usuario o de su equipo y, dependiendo de la información que contengan y de la forma en que utilice su equipo, pueden utilizarse para reconocer al usuario. Las cookies se asocian únicamente a un usuario anónimo y su ordenador o dispositivo y no proporcionan referencias que permitan conocer sus datos personales.
                            </p>
                            <br />

                            <h4>3.- TIPOS DE COOKIES</h4>
                            <h5>3.1.- Según la entidad que las gestiona</h5>
                            <ul>
                                <li><b>Cookies propias:</b> Son aquéllas que se envían al equipo terminal del usuario desde un equipo o dominio gestionado por el propio editor y desde el que se presta el servicio solicitado por el usuario.</li>
                                <li><b>Cookies de terceros:</b> Son aquéllas que se envían al equipo terminal del usuario desde un equipo o dominio que no es gestionado por el editor, sino por otra entidad que trata los datos obtenidos a través de las cookies.</li>
                            </ul>
                            
                            <h5>3.2.- Según la finalidad</h5>
                            <ul>
                                <li><b>Cookies técnicas:</b> son aquellas que permiten al usuario la navegación a través de una página web, plataforma o aplicación y la utilización de las diferentes opciones o servicios que en ella existan.</li>
                                <li><b>Cookies de preferencias o personalización:</b> son aquellas que permiten recordar información para que el usuario acceda al servicio con determinadas características que pueden diferenciar su experiencia de la de otros usuarios.</li>
                                <li><b>Cookies de análisis o medición:</b> son aquellas que permiten al responsable de las mismas el seguimiento y análisis del comportamiento de los usuarios de los sitios web a los que están vinculadas.</li>
                                <li><b>Cookies de publicidad comportamental:</b> son aquellas que almacenan información del comportamiento de los usuarios obtenida a través de la observación continuada de sus hábitos de navegación, lo que permite desarrollar un perfil específico para mostrar publicidad en función del mismo.</li>
                            </ul>
                            
                            <h5>3.3.- Según el plazo de tiempo que permanecen activadas</h5>
                            <ul>
                                <li><b>Cookies de sesión:</b> son aquellas diseñadas para recabar y almacenar datos mientras el usuario accede a una página web.</li>
                                <li><b>Cookies persistentes:</b> son aquellas en las que los datos siguen almacenados en el terminal y pueden ser accedidos y tratados durante un periodo definido por el responsable de la cookie.</li>
                            </ul>
                            <br />

                            <h4>4.- LISTADO DE COOKIES UTILIZADAS POR ESTE SITIO WEB</h4>
                            <p>
                                La utilización de las cookies ofrece ventajas en la prestación de servicios dentro de lo que se conoce como la sociedad de la información, puesto que, facilita al usuario la navegación y el acceso a los diferentes servicios que ofrece este sitio web; evita al usuario tener que configurar las características generales predefinidas cada vez que accede al sitio web; favorece la mejora del funcionamiento y de los servicios prestados a través de este sitio web, tras el correspondiente análisis de la información obtenida a través de las cookies instaladas.
                            </p>
                            <p>
                                En concreto este sitio web utiliza las siguientes cookies:
                            </p>
                            <Table striped bordered hover className="my-3">
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Entidad</th>
                                        <th>Caducidad</th>
                                        <th>Finalidad</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><code>cc_cookie</code></td>
                                        <td>Propia (Gecor System S.L.U.)</td>
                                        <td>365 días</td>
                                        <td>Técnica / Estrictamente necesaria. Se utiliza para recordar y almacenar las preferencias del usuario sobre el consentimiento de las cookies.</td>
                                    </tr>
                                    <tr>
                                        <td><code>_ga</code></td>
                                        <td>De Terceros (Google Analytics)</td>
                                        <td>2 años</td>
                                        <td>Análisis y Rendimiento. Calcula datos de visitantes, sesiones, campañas y rastrea el uso del sitio web.</td>
                                    </tr>
                                    <tr>
                                        <td><code>_gid</code></td>
                                        <td>De Terceros (Google Analytics)</td>
                                        <td>24 horas</td>
                                        <td>Análisis y Rendimiento. Almacena y actualiza un valor único para cada página visitada, permitiendo distinguir a los usuarios en un día.</td>
                                    </tr>
                                    <tr>
                                        <td>Cookies de YouTube</td>
                                        <td>De Terceros (YouTube)</td>
                                        <td>Variable</td>
                                        <td>Técnicas y Preferencias. Registra estadísticas de reproducción, preferencias de interfaz de vídeo y mide el ancho de banda.</td>
                                    </tr>
                                    <tr>
                                        <td>Cookies de Publicidad (Ads)</td>
                                        <td>De Terceros (Redes Publicitarias)</td>
                                        <td>Variable</td>
                                        <td>Publicidad y Segmentación. Almacena hábitos de navegación para crear perfiles específicos y mostrar anuncios personalizados.</td>
                                    </tr>
                                </tbody>
                            </Table>
                            <br />

                            <h4>5.- REVOCACIÓN Y ELIMINACIÓN DE COOKIES</h4>
                            <p>
                                En todo momento podrá acceder a la configuración de su navegador aceptando o rechazando todas las cookies, o bien seleccionar aquéllas cuya instalación admite y cuáles no, siguiendo los procedimientos propios del navegador que utilice.
                            </p>
                            <p>
                                Además, este sitio web cuenta con un gestor de cookies integrado (basado en vanilla-cookieconsent) que le permite controlar en todo momento qué grupos de cookies (estrictamente necesarias, análisis o publicidad) desea permitir o rechazar de manera sencilla.
                            </p>
                            <div className="text-center my-3">
                                <Button variant="outline-primary" data-cc="show-preferencesModal">
                                    Controlar preferencias de cookies
                                </Button>
                            </div>
                            <br />

                            <h4>6.- TERCEROS PRESTADORES DE SERVICIOS</h4>
                            <p>
                                Los terceros prestadores de servicios con los que hemos contratado algún servicio para el que es necesario la utilización de cookies son los que se listan a continuación:
                            </p>
                            <Table striped bordered hover className="my-3">
                                <thead>
                                    <tr>
                                        <th>Proveedor</th>
                                        <th>Finalidad del Servicio y de la Cookie</th>
                                        <th>Información del Proveedor</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Google Analytics (Google Inc.)</td>
                                        <td>Análisis y rendimiento del sitio web a nivel de contabilización de visitantes, sesiones, páginas visitadas y similares.</td>
                                        <td><a href="http://www.google.es/intl/es/policies/privacy/" target="_blank" rel="noopener noreferrer">http://www.google.es/intl/es/policies/privacy/</a></td>
                                    </tr>
                                    <tr>
                                        <td>YouTube (Google Inc.)</td>
                                        <td>Incrustación de vídeos (Youtube Embed), estadísticas de reproducción y almacenamiento de preferencias del usuario.</td>
                                        <td><a href="https://policies.google.com/privacy?hl=es" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy?hl=es</a></td>
                                    </tr>
                                    <tr>
                                        <td>Redes Publicitarias (Ads)</td>
                                        <td>Creación de perfiles específicos basados en hábitos de navegación para mostrar publicidad personalizada.</td>
                                        <td>Dependiendo de la red específica autorizada por el usuario en el gestor de preferencias.</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    </Card.Body>
                </Card>
            </Container>
        );
    }
}

export { CookiePage };